module.exports = __webpack_public_path__ + "img/5.7e341ac.jpg";